import { useFilteredEntryCount } from 'features/drilldown/rolodex/dataHelpers/drilldownDataHelpers'
import { FC } from 'react'

import { COMPLETED_INSPECTION_FILTER } from './DrilldownCountsView'
import { StatDisplayCount } from './statDisplay/StatDisplayCount'

const INSPECTION_COUNT_VIEW_ROLODEX_TYPE = 'inspection'

export const ScheduledInspectionCountView: FC<{
  title: string
}> = ({ title }) => {
  const {
    count: completedInspectionCount,
    isLoading: isLoadingCompletedInspections,
  } = useFilteredEntryCount(
    INSPECTION_COUNT_VIEW_ROLODEX_TYPE,
    COMPLETED_INSPECTION_FILTER
  )
  const { count: totalInspectionCount, isLoading: isLoadingAllInspections } =
    useFilteredEntryCount(INSPECTION_COUNT_VIEW_ROLODEX_TYPE)

  const scheduledInspectionCount =
    totalInspectionCount - completedInspectionCount

  return (
    <StatDisplayCount
      title={title}
      count={scheduledInspectionCount}
      isLoading={isLoadingCompletedInspections || isLoadingAllInspections}
    />
  )
}
